import {
  luckBlocksAddress,
  luckBlocksWAddress,
  ethLuckBlocksAddress,
  ethluckBlocksWAddress,
  maticLuckBlocksAddress,
  maticLuckBlocksWAddress,
  CRANNILuckBlocksAddress,
  CRANNILuckBlocksWAddress,
  bullvsbear,
  cynthsOracleAddress,
  bestiariumAddress,
} from '../../.config';
import { bullsEyeAddress } from '../../pages/BullsEye/config';
import { ArrowUpDown, Crosshair, PawPrint } from 'lucide-react';
import btcIcon from '../../assets/utility/bitcoin.png';
import ethIcon from '../../assets/utility/ethereum.png';
import polIcon from '../../assets/utility/matic.png';
import cranniIcon from '../../assets/utility/CRANNI.png';
import ciBoldIcon from '../../assets/unisynths/ciBOLD.png';

// Everything NFT nodes run, through the standard node task interface (ILuckblocksNodeTask)
export const PLATFORMS = [
  { key: 'btcDaily', name: 'tasks.name.btcDaily', group: 'lotteries', address: luckBlocksAddress, reward: 'tasks.reward.daily', image: btcIcon },
  { key: 'ethDaily', name: 'tasks.name.ethDaily', group: 'lotteries', address: ethLuckBlocksAddress, reward: 'tasks.reward.daily', image: ethIcon },
  { key: 'polDaily', name: 'tasks.name.polDaily', group: 'lotteries', address: maticLuckBlocksAddress, reward: 'tasks.reward.daily', image: polIcon },
  { key: 'cranniDaily', name: 'tasks.name.cranniDaily', group: 'lotteries', address: CRANNILuckBlocksAddress, reward: 'tasks.reward.daily', image: cranniIcon },
  { key: 'btcWeekly', name: 'tasks.name.btcWeekly', group: 'lotteries', address: luckBlocksWAddress, reward: 'tasks.reward.weekly', image: btcIcon },
  { key: 'ethWeekly', name: 'tasks.name.ethWeekly', group: 'lotteries', address: ethluckBlocksWAddress, reward: 'tasks.reward.weekly', image: ethIcon },
  { key: 'polWeekly', name: 'tasks.name.polWeekly', group: 'lotteries', address: maticLuckBlocksWAddress, reward: 'tasks.reward.weekly', image: polIcon },
  { key: 'cranniWeekly', name: 'tasks.name.cranniWeekly', group: 'lotteries', address: CRANNILuckBlocksWAddress, reward: 'tasks.reward.weekly', image: cranniIcon },
  { key: 'bullVsBear', name: 'tasks.name.bullVsBear', group: 'games', address: bullvsbear, reward: 'tasks.reward.bullVsBear', Icon: ArrowUpDown },
  { key: 'bullsEye', name: 'tasks.name.bullsEye', group: 'games', address: bullsEyeAddress, reward: 'tasks.reward.bullsEye', Icon: Crosshair },
  { key: 'bestiarium', name: 'tasks.name.bestiarium', group: 'games', address: bestiariumAddress, reward: 'tasks.reward.bestiarium', Icon: PawPrint },
  { key: 'ciBold', name: 'tasks.name.ciBold', group: 'synths', address: cynthsOracleAddress, reward: 'tasks.reward.ciBold', image: ciBoldIcon },
].filter((platform) => platform.address);

export const platformOf = (address) =>
  PLATFORMS.find((platform) => platform.address.toLowerCase() === String(address || '').toLowerCase());
